import { boolean, OutSearchParams, route, string } from 'react-router-typesafe-routes';

import { civilDate, formatCivilDate } from '@utils/civilDate';
import { DateHelper } from '@utils/DateHelper';

const CURRENT_WEEK_START = DateHelper.startOfWeek(new Date());

export const SCHEDULE_DEVICES_ROUTE = route({
    path: 'schedule/devices',
    searchParams: {
        from: string(civilDate).default(formatCivilDate(CURRENT_WEEK_START)),
        to: string(civilDate).default(formatCivilDate(DateHelper.addDays(CURRENT_WEEK_START, 6))),
        organizationId: string(),
        deviceId: string().array(),
        cancelledReservations: boolean().default(false),
        confidential: boolean().default(false),
    },
});

export type ScheduleDevicesUrlState = OutSearchParams<typeof SCHEDULE_DEVICES_ROUTE.$spec>;
